import { render, staticRenderFns } from "./ManageInformation.vue?vue&type=template&id=448f7349"
import script from "./ManageInformation.vue?vue&type=script&lang=js"
export * from "./ManageInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports